export enum CashPlusMoneyMarketTickers {
  VMRXX = 'VMRXX',
  VMSXX = 'VMSXX',
  VYFXX = 'VYFXX',
  VUSXX = 'VUSXX',
  VCTXX = 'VCTXX',
}

export const cashPlusTickers: Set<string> = new Set(Object.values(CashPlusMoneyMarketTickers));

export enum DecimalInputMoneyMarketTickers {
  VMRXX = 'VMRXX',
  VMSXX = 'VMSXX',
  VYFXX = 'VYFXX',
  VUSXX = 'VUSXX',
  VCTXX = 'VCTXX',
  VMFXX = 'VMFXX',
}
export const DecimalInputMoneyMarketTickersList: string[] = Object.values(
  DecimalInputMoneyMarketTickers,
);
